import NetworkService from '../services/network.service'

class SettingsApi {
  getUsers = async () => {

    let url = `api/settings/getUsers`;
    let params = {}
    let data = await NetworkService.get(url, params)
    return data && data.data
      ? data.data : data

  };

  getUserSettings = async (userId: any) => {

    let url = `api/settings/user`;
    let config = {
      params: {
        'userid': userId   
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data[0] : data

  };
  getTicketSettings = async () => {

    let url = `api/settings/ticket`;
    let params = {}
    let data = await NetworkService.get(url, params)
    return data && data.data
      ? data.data : data

  };

  saveTicketSettings = async (settings: any) => {

    let url = `api/settings/ticket`;
    let data = await NetworkService.put(url, settings)
    return data && data.data
      ? data.data : data

  };

  saveUserSettings = async (settings: any) => {

    let url = `api/settings/user`;
    let data = await NetworkService.put(url, settings)
    return data && data.data
      ? data.data : data

  };

  updateSettings = async (collection: any, settings: any) => {
    const {companyId} = settings;
    let url = `api/settings/${collection}/${companyId}`;
    let data = await NetworkService.put(url, settings)
    return data && data.data
      ? data.data : data

  };

}
export default SettingsApi;